import React from 'react';
import {useStores} from "../../../stores/Context";

const WidgetBibliothequeImagesAddPhoto = () => {
    const {uiStore, bibliothequeImagesStore} = useStores();

    return (
        <div className={"bibliothequeModifyBody"} style={{ display: "flex", flexDirection: "column", height: "100%", justifyContent: "space-around" }}>

            <div className={"consigneModifyHeader"}>
                <h3 className={"consigneModifyTitleH3"}>
                    Ajouter une image
                </h3>
                <div onClick={() => bibliothequeImagesStore.handleCloseAddPhoto()} style={{ cursor: "pointer", rotate: "180deg" }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B" stroke-width="2"/>
                        <line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B" stroke-width="2"/>
                        <line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B" stroke-width="2"/>
                    </svg>
                </div>
            </div>
            <div className={"consigneModifyHeaderSeparateur"}></div>

            <div className={"bibliothequeImagesBtnAddViewContent"}>
                <button className={"bibliothequeImagesBtnAddView"}
                        onClick={() => bibliothequeImagesStore.handleOpenUploadImage()}
                >
                    <span>
                        <svg width="50px" height="50px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M17 17H17.01M15.6 14H18C18.9319 14 19.3978 14 19.7654 14.1522C20.2554 14.3552 20.6448 14.7446 20.8478 15.2346C21 15.6022 21 16.0681 21 17C21 17.9319 21 18.3978 20.8478 18.7654C20.6448 19.2554 20.2554 19.6448 19.7654 19.8478C19.3978 20 18.9319 20 18 20H6C5.06812 20 4.60218 20 4.23463 19.8478C3.74458 19.6448 3.35523 19.2554 3.15224 18.7654C3 18.3978 3 17.9319 3 17C3 16.0681 3 15.6022 3.15224 15.2346C3.35523 14.7446 3.74458 14.3552 4.23463 14.1522C4.60218 14 5.06812 14 6 14H8.4M12 15V4M12 4L15 7M12 4L9 7" stroke="#a8b0b3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </span>
                    Importer une image
                </button>
                <button className={"bibliothequeImagesBtnAddView"}
                        onClick={() => bibliothequeImagesStore.handleOpenCamera()}
                >

                    <span>
                        <svg fill="#a8b0b3" width="50px" height="50px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>photo</title> <path d="M0 28v-20q0-0.832 0.576-1.408t1.44-0.576h4q0.8 0 1.408-0.576t0.576-1.44 0.576-1.408 1.44-0.576h12q0.8 0 1.408 0.576t0.576 1.408 0.576 1.44 1.44 0.576h4q0.8 0 1.408 0.576t0.576 1.408v20q0 0.832-0.576 1.44t-1.408 0.576h-28q-0.832 0-1.44-0.576t-0.576-1.44zM6.016 16q0 2.048 0.768 3.904t2.144 3.168 3.2 2.144 3.872 0.8q2.72 0 5.024-1.344t3.648-3.648 1.344-5.024-1.344-4.992-3.648-3.648-5.024-1.344q-2.016 0-3.872 0.8t-3.2 2.112-2.144 3.2-0.768 3.872zM10.016 16q0-2.464 1.728-4.224t4.256-1.76 4.256 1.76 1.76 4.224-1.76 4.256-4.256 1.76-4.256-1.76-1.728-4.256z"></path> </g></svg>
                    </span>
                    Prendre une photo
                </button>
                {
                    /*
                    <button className={"bibliothequeImagesBtnAddView"}
                        onClick={() => bibliothequeImagesStore.handleOpenUploadQrCode()}
                >
                    <span>
                        <svg width="50px" height="50px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#a8b0b3"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3,11H5v2H3V11m8-6h2V9H11V5M9,11h4v4H11V13H9V11m6,0h2v2h2V11h2v2H19v2h2v4H19v2H17V19H13v2H11V17h4V15h2V13H15V11m4,8V15H17v4h2M15,3h6V9H15V3m2,2V7h2V5H17M3,3H9V9H3V3M5,5V7H7V5H5M3,15H9v6H3V15m2,2v2H7V17Z"></path> <rect width="24" height="24" fill="none"></rect> </g></svg>
                    </span>
                    Depuis un QR Code
                </button>
                     */
                }

            </div>


        </div>
    );
};

export default WidgetBibliothequeImagesAddPhoto;